import { LoaderCircle } from "lucide-react";
import { useState } from "react";
import type { Student } from "../types";

type Props = {
  student: Student;
  onChange: (student: Student, status: Student["status"]) => Promise<void>;
};

export default function StudentStatusSelect({ student, onChange }: Props) {
  const [saving, setSaving] = useState(false);
  return <div className={`student-status student-status--${student.status}`}>
    <i aria-hidden="true" />
    <select aria-label={`Trạng thái của ${student.lastName} ${student.firstName}`} value={student.status} disabled={saving} onChange={async (event) => {
      setSaving(true);
      try { await onChange(student, event.target.value as Student["status"]); }
      finally { setSaving(false); }
    }}>
      <option value="active">Đang học</option><option value="inactive">Nghỉ</option>
    </select>
    {saving && <LoaderCircle className="spin" size={14} />}
  </div>;
}
